var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputerScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#286795",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M1.63 12.8c.074.509.514.889 1.029.874 2.377-.068 4.797-.165 7.34-.165 2.538 0 4.962.06 7.327.152.52.02.971-.361 1.046-.877.24-1.659.556-3.395.556-5.184 0-1.784-.314-3.517-.554-5.172a1.027 1.027 0 0 0-1.06-.88c-2.334.107-4.786.144-7.314.144-2.535 0-4.984-.073-7.33-.157a1.02 1.02 0 0 0-1.042.877c-.24 1.66-.557 3.398-.557 5.188 0 1.794.318 3.536.559 5.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M6.44 17.875h7.12M10 13.512v4.362"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerScreen);
export default __webpack_public_path__ + "static/media/computer-screen.70520dfbabff182975c8b6ffbf32cbd2.svg";
export { ForwardRef as ReactComponent };